import { jsx as l } from "react/jsx-runtime";
import { c as s } from "../clsx-OuTLNxxd.js";
import { T as d, h as _, g as m, a as y, d as T, c as i, e as p } from "../Table-dMh9ujGh.js";
import { T as C } from "../TableScrollContainer-B3DK6eX9.js";
import '../StatsTable.css';const w = "_wrapper_1y416_32", h = "_table_1y416_54", u = "_tableHead_1y416_62", N = "_tableColumn_1y416_70", S = "_tableBody_1y416_84", B = "_tableRow_1y416_88", F = "_tableCell_1y416_91", H = "_tableFooter_1y416_101", o = {
  wrapper: w,
  table: h,
  tableHead: u,
  tableColumn: N,
  tableBody: S,
  tableRow: B,
  tableCell: F,
  tableFooter: H
}, c = ({
  caption: e,
  cellWidth: t = 60,
  children: a,
  className: n,
  maxRows: b,
  ...r
}) => /* @__PURE__ */ l(
  C,
  {
    caption: e,
    cellWidth: t,
    className: s(o.wrapper, n),
    maxRows: b,
    ...r,
    children: /* @__PURE__ */ l(d, { className: o.table, "data-testid": "stats-table", children: a })
  }
), R = ({ children: e, className: t, ...a }) => /* @__PURE__ */ l(_, { className: s(o.tableRow, t), size: "s", ...a, children: e }), g = ({
  children: e,
  className: t,
  justifyContent: a = "center",
  pinned: n,
  ...b
}) => /* @__PURE__ */ l(
  T,
  {
    className: s(o.tableColumn, t),
    "data-justify": a,
    "data-pinned": n,
    "data-type": "heading",
    justifyContent: a,
    ...b,
    children: e
  }
), f = ({
  children: e,
  className: t,
  justifyContent: a = "center",
  pinned: n,
  ...b
}) => /* @__PURE__ */ l(
  i,
  {
    className: s(o.tableCell, t),
    "data-highlight": !!b.highlight,
    "data-justify": a,
    "data-pinned": n,
    justifyContent: a,
    ...b,
    children: e
  }
), x = ({ children: e, className: t, ...a }) => /* @__PURE__ */ l(p, { ...a, className: s(o.tableFooter, t), children: e }), j = ({ children: e, className: t, ...a }) => /* @__PURE__ */ l(m, { ...a, className: s(o.tableHead, t), children: e }), z = ({ children: e, className: t, ...a }) => /* @__PURE__ */ l(y, { className: s(o.tableBody, t), ...a, children: e });
c.Row = R;
c.Head = j;
c.Body = z;
c.Column = g;
c.Cell = f;
c.Footer = x;
export {
  c as StatsTable
};
